import { AgentAvatar } from "./AgentAvatar.js";
import { cn } from "./cn.js";
import { AGENTS, type AgentId, type AgentRoom } from "./nav.js";
import { ChevronRightIcon } from "lucide-react";

type Props = {
	setupDone: boolean;
	onOpen: (id: AgentId) => void;
};

function AgentRow({
	agent,
	locked,
	soon,
	onOpen,
}: {
	agent: AgentRoom;
	locked: boolean;
	soon: boolean;
	onOpen: (id: AgentId) => void;
}) {
	const blocked = locked || soon;
	return (
		<li>
			<button
				type="button"
				className={cn(
					"agents-person",
					blocked && "agents-person--muted",
				)}
				disabled={blocked}
				onClick={() => onOpen(agent.id)}
				aria-label={
					locked
						? `${agent.name} locked`
						: soon
							? `${agent.name} coming soon`
							: `Message ${agent.name}`
				}
			>
				<AgentAvatar agent={agent} size="md" />
				<span className="min-w-0 flex-1 text-left">
					<span className="agents-person-name">{agent.name}</span>
					<span className="agents-person-role">{agent.title}</span>
				</span>
				{soon ? (
					<span className="agents-person-soon">Soon</span>
				) : (
					<ChevronRightIcon
						className="size-4 shrink-0 text-mx-quaternary"
						aria-hidden
					/>
				)}
			</button>
		</li>
	);
}

/** Click a name to message them. No grid, filters, or profile chrome. */
export function AgentsHub({ setupDone, onOpen }: Props) {
	const live = AGENTS.filter((agent) => agent.availability === "live");
	const soon = AGENTS.filter((agent) => agent.availability === "soon");

	return (
		<>
			<header className="main-header agents-hub-header">
				<div className="min-w-0">
					<h1 className="main-title">Agents</h1>
				</div>
			</header>
			<div className="main sites-hub">
				<ul className="agents-people">
					{live.map((agent) => (
						<AgentRow
							key={agent.id}
							agent={agent}
							locked={!setupDone && agent.id !== "onboarding"}
							soon={false}
							onOpen={onOpen}
						/>
					))}
				</ul>
				{soon.length > 0 ? (
					<>
						<p className="agents-soon-label">Soon</p>
						<ul className="agents-people">
							{soon.map((agent) => (
								<AgentRow
									key={agent.id}
									agent={agent}
									locked={false}
									soon
									onOpen={onOpen}
								/>
							))}
						</ul>
					</>
				) : null}
			</div>
		</>
	);
}
